 import './Teste1.css';

 const Teste1 = () => { 
   return (
     <div className="teste1-container">
       <h1>Teste1 Component</h1>
       <p> ISSO É UM TESTE </p>
     </div>
   );
 }

 export default Teste1;

 